import { render, staticRenderFns } from "./teachTime.vue?vue&type=template&id=adb764e4&"
import script from "./teachTime.vue?vue&type=script&lang=ts&"
export * from "./teachTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports